import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_OPTIMIZELY_EVENT_SAFELIST = defineFcm('optimizely_event_safelist')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'string',
			},
		}),
	)
	.withDefault([])
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'front-end (optimizely)',
		description: `When the front-end tracks an event, if that event is part of this safe list, the even will be also sent to Optimizely using "optimizely.push()".

Related FCM: optimizely_property_safelist`,
		template: ['petition_view'],
	});
